import React, { useState, useEffect } from "react";
import Chat from "./chat";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { ReactComponent as ReactLogoIcon } from "../../assets/icons/react-logo.svg";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";

const FloatingChat: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [clearTrigger, setClearTrigger] = useState(0);

  // --- SCROLL LOCK LOGIC ---
  useEffect(() => {
    if (isOpen) {
      // Prevent the background page from scrolling
      document.body.style.overflow = "hidden";
      // Optional: Add padding to prevent "jumping" if scrollbar disappears
      document.body.style.paddingRight = "0px"; 
    } else {
      // Allow the background page to scroll again
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "0px";
    }

    // Cleanup function to ensure scroll is restored if component unmounts
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const toggleTheme = () => setIsDark(!isDark);

  return (
    <>
      {!isOpen && (
        <Tooltip
          title="Ask AI"
          placement="top"
          arrow
          enterDelay={180}
          slotProps={{
            popper: {
              sx: { zIndex: 10002 },
            },
            tooltip: {
              sx: {
                bgcolor: "#1d4ed8",
                color: "#fff",
                fontWeight: 600,
                fontSize: "0.8125rem",
                letterSpacing: "0.02em",
                px: 2,
                py: 1,
                borderRadius: "999px",
                border: "1px solid rgba(255, 255, 255, 0.22)",
                boxShadow:
                  "0 12px 32px rgba(37, 99, 235, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.15)",
              },
            },
            arrow: {
              sx: { color: "#1d4ed8" },
            },
          }}
        >
          <Fab
            onClick={() => setIsOpen(true)}
            aria-label="Ask AI"
            className="ai-fab"
            sx={{
              position: "fixed",
              bottom: 100,
              right: 30,
              width: 76,
              height: 76,
              background:
                "linear-gradient(145deg, #60a5fa 0%, #2563eb 42%, #1d4ed8 100%)",
              color: "white",
              zIndex: 1000,
              border: "1px solid rgba(255, 255, 255, 0.25)",
              boxShadow:
                "0 12px 40px rgba(37, 99, 235, 0.42), 0 4px 14px rgba(15, 23, 42, 0.12)",
              transition:
                "transform 0.28s cubic-bezier(0.34, 1.45, 0.64, 1), box-shadow 0.28s ease, filter 0.28s ease",
              "&:hover": {
                transform: "scale(1.06) translateY(-3px)",
                boxShadow:
                  "0 18px 48px rgba(37, 99, 235, 0.5), 0 8px 20px rgba(15, 23, 42, 0.14)",
                filter: "brightness(1.05)",
                background:
                  "linear-gradient(145deg, #93c5fd 0%, #3b82f6 40%, #2563eb 100%)",
              },
              "&:active": {
                transform: "scale(0.98) translateY(0)",
                boxShadow:
                  "0 8px 24px rgba(37, 99, 235, 0.35), 0 2px 8px rgba(15, 23, 42, 0.1)",
              },
            }}
          >
            <ReactLogoIcon
              className="ai-fab-icon"
              aria-hidden
              style={{
                width: 46,
                height: 46,
                display: "block",
                filter: "drop-shadow(0 2px 5px rgba(15, 23, 42, 0.22))",
              }}
            />
          </Fab>
        </Tooltip>
      )}

      <div
        className={`ai-widget-wrapper ${isDark ? "dark" : "light"}`}
        style={{ display: isOpen ? "flex" : "none" }}
        aria-hidden={!isOpen}
      >
        <div className="ai-widget-container">
          <header className="ai-header">
            <span className="header-title">Bookstore AI Assistant</span>
            <div className="header-actions">
              <button className="action-btn" onClick={toggleTheme}>
                {isDark ? (
                  <LightModeIcon fontSize="small" />
                ) : (
                  <DarkModeIcon fontSize="small" />
                )}
              </button>
              <button
                className="action-btn clear"
                onClick={() => {
                  Swal.fire({
                    icon: "error",
                    title: "Are you sure?",
                    text: "Are you sure to clear all?",
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#2563eb",
                    cancelButtonText: "Cancel",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      setClearTrigger((p) => p + 1);
                    }
                  });
                }}
              >
                <DeleteSweepIcon fontSize="small" />
              </button>
              <button
                className="action-btn close"
                onClick={() => setIsOpen(false)}
              >
                <CloseIcon fontSize="small" />
              </button>
            </div>
          </header>

          <Chat clearTrigger={clearTrigger} />
        </div>
      </div>
    </>
  );
};

export default FloatingChat;